import type { MenuProps } from 'antd'

export type SelectionType = 'text' | 'image' | 'none'

export const suggestionsBySelection: Record<SelectionType, MenuProps['items']> =
  {
    text: [
      {
        type: 'group',
        label: 'Suggested',
        children: [
          { key: 'improve', label: 'Improve writing' },
          { key: 'grammar', label: 'Fix spelling & grammar' },
          {
            key: 'translate',
            label: 'Translate to',
            children: [
              { key: 'translate-en', label: 'English' },
              { key: 'translate-fr', label: 'French' },
              { key: 'translate-de', label: 'German' },
              { key: 'translate-it', label: 'Italian' },
              { key: 'translate-es', label: 'Spanish' },
              { key: 'translate-pt', label: 'Portuguese' },
              { key: 'translate-nl', label: 'Dutch' },
              { key: 'translate-ru', label: 'Russian' },
              { key: 'translate-ja', label: 'Japanese' },
              { key: 'translate-ko', label: 'Korean' },
              { key: 'translate-zh-s', label: 'Chinese, Simplified' },
              { key: 'translate-zh-t', label: 'Chinese, Traditional' },
              { key: 'translate-id', label: 'Indonesian' },
              { key: 'translate-fil', label: 'Filipino' },
              { key: 'translate-vi', label: 'Vietnamese' },
            ],
          },
        ],
      },
      {
        type: 'group',
        label: 'Edit',
        children: [
          { key: 'shorter', label: 'Make shorter' },
          { key: 'simplify', label: 'Simplify language' },
          {
            key: 'tone',
            label: 'Change tone',
            children: [
              { key: 'tone-professional', label: 'Professional' },
              { key: 'tone-casual', label: 'Casual' },
              { key: 'tone-straightforward', label: 'Straightforward' },
              { key: 'tone-confident', label: 'Confident' },
              { key: 'tone-friendly', label: 'Friendly' },
            ],
          },
          { key: 'longer', label: 'Make longer' },
        ],
      },
    ],
    image: [
      {
        type: 'group',
        label: 'Image Suggestions',
        children: [
          { key: 'fix-spelling', label: 'Correct spelling' },
          { key: 'remove-bg', label: 'Remove background' },
          { key: 'brand-color', label: 'Apply brand color' },
        ],
      },
    ],
    none: [],
  }

export const suggestionKeyToGuideline: Record<string, string> = {
  // Text mappings
  improve: 'Improve writing',
  grammar: 'Fix spelling & grammar',
  'translate-en': 'Translate to English',
  'translate-fr': 'Translate to French',
  'translate-de': 'Translate to German',
  'translate-it': 'Translate to Italian',
  'translate-es': 'Translate to Spanish',
  'translate-pt': 'Translate to Portuguese',
  'translate-nl': 'Translate to Dutch',
  'translate-ru': 'Translate to Russian',
  'translate-ja': 'Translate to Japanese',
  'translate-ko': 'Translate to Korean',
  'translate-zh-s': 'Translate to Chinese, Simplified',
  'translate-zh-t': 'Translate to Chinese, Traditional',
  'translate-id': 'Translate to Indonesian',
  'translate-fil': 'Translate to Filipino',
  'translate-vi': 'Translate to Vietnamese',
  shorter: 'Make shorter',
  simplify: 'Simplify language',
  longer: 'Make longer',
  'tone-professional': 'Tone: Professional',
  'tone-casual': 'Tone: Casual',
  'tone-straightforward': 'Tone: Straightforward',
  'tone-confident': 'Tone: Confident',
  'tone-friendly': 'Tone: Friendly',

  // Image mappings
  'remove-bg': 'Remove image background wihtout altering the main subject.',
  'fix-spelling': 'Correct spelling wihtout altering the sentences.',
  'brand-color':
    'Gently blend the brand color into the image’s lighting and ambiance without altering the main subject.',
}
